
module.exports = require('./lib/svg-path-generator');

